module.exports = "<backup-page></backup-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/backup.html
// module id = 1786
// module chunks = 0